import React, { useEffect, useRef } from 'react';
import QRCode from 'qrcode';

interface QRCodeProps {
  text: string;
  size?: number;
  lightColor?: string;
  darkColor?: string;
  className?: string;
}

export function StyledQRCode({
  text,
  size = 250,
  lightColor = '#ffffff',
  darkColor = '#4f46e5',
  className = '',
}: QRCodeProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    QRCode.toCanvas(
      canvasRef.current,
      text,
      {
        width: size,
        margin: 1,
        color: {
          dark: darkColor,
          light: lightColor,
        },
      },
      (error:any) => {
        if (error) console.error('Error generating QR code:', error);
      }
    );
  }, [text, size, lightColor, darkColor]);

  return (
    <div className={`inline-block rounded-xl shadow-lg ${className}`}>
      <canvas ref={canvasRef} />
    </div>
  );
}